import React from 'react';
import { Link } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';

export interface SubmenuAction {
  label: string;
  icon: string;
  onClick?: () => void;
  to?: string;
}

interface SubmenuProps {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  actions: SubmenuAction[];
}

const StyledMenuItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 0.875rem !important;
  color: var(--text) !important;
  height: 40px;
  padding: 0 16px !important;
  width: 100%;

  &:hover .icon {
    color: var(--highlight);
  }

  .icon {
    color: var(--header);
    font-size: 12px;
    width: 12px;
    height: 12px;
    transition: color var(--transition);
  }

  a {
    display: flex;
    align-items: center;
    gap: 14px;
    color: inherit;
    text-decoration: none;
    width: 100%;
    height: 100%;
  }
`;

export const Submenu: React.FC<SubmenuProps> = ({ open, onClose, anchorEl, actions }) => {
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        '& .MuiPaper-root': {
          backgroundColor: 'var(--tooltip-bg)',
          borderRadius: '4px',
          boxShadow: 'var(--widget-shadow)',
          marginTop: '6px',
        },
        '& .MuiMenu-list': {
          padding: 0,
        },
        '& .MuiButtonBase-root': {
          padding: '0 16px',
          width: '100%',
          '&:not(:last-child)': {
            borderBottom: '1px solid var(--divider)',
          },
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      }}
    >
      {actions.map((action, index) => (
        <StyledMenuItem
          key={index}
          onClick={() => {
            if (action.onClick) {
              action.onClick();
            }
            onClose();
          }}
        >
          {action.to ? (
            <Link to={action.to}>
              <i className={`icon icon-${action.icon}`} />
              {action.label}
            </Link>
          ) : (
            <>
              <i className={`icon icon-${action.icon}`} />
              {action.label}
            </>
          )}
        </StyledMenuItem>
      ))}
    </Menu>
  );
};

export default Submenu;
